module.exports = __webpack_public_path__ + "img/01743404001290.c1763f2d.png";